module.exports = __webpack_public_path__ + "static/media/downloadAll.522643be.svg";